const filters = {
  header: {
    title: "Фильтры контента",
    description: "Подходящие публикации попадают в «Ожидают проверки», остальные сразу отправляются в архив.",
  },
  caseSensitive: {
    label: "Учитывать регистр",
    enabled: "Сопоставление с учётом регистра включено",
    disabled: "Сопоставление с учётом регистра выключено",
  },
  positive: {
    label: "Положительные ключевые слова (запускают обработку)",
    inputLabel: "Добавить положительное ключевое слово или фразу",
    placeholder: "например: AI, startup, benchmark",
    empty: "Положительные ключевые слова не добавлены. Если ключевые слова и хэштеги не заданы, подходят все собранные публикации.",
    remove: "Удалить положительное ключевое слово {{value}}",
  },
  hashtags: {
    label: "Обязательные хэштеги",
    inputLabel: "Добавить обязательный хэштег",
    placeholder: "tech, ai, health",
    empty: "Обязательные хэштеги не добавлены.",
    remove: "Удалить хэштег {{value}}",
  },
  negative: {
    label: "Отрицательные ключевые слова (сразу игнорировать/архивировать)",
    inputLabel: "Добавить отрицательное ключевое слово или фразу",
    placeholder: "например: promo, airdrop, crypto, spam",
    empty: "Отрицательные ключевые слова не добавлены. Добавьте, например, «spam» или «ad», чтобы автоматически исключать совпадающие публикации.",
    remove: "Удалить отрицательное ключевое слово {{value}}",
  },
  actions: {
    addPositive: "Добавить положительное ключевое слово",
    addHashtag: "Добавить обязательный хэштег",
    addNegative: "Добавить отрицательное ключевое слово",
  },
} as const;

export default filters;
